import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type OrderNoteFragment = { id: string, pk: number, content: string, isPublic: boolean, date: any, creator: string, replyToMe: boolean };

export const OrderNoteFragmentDoc = gql`
    fragment OrderNoteFragment on OrderNoteType {
  id
  pk
  content
  isPublic
  date
  creator
  replyToMe
}
    `;